// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"JZ-z","subtitle":"KZ-z","wrapper":"LZ-z","leftArrow":"MZ-z","rightArrow":"NZ-z"};